<template>
  <v-container>
    <v-flex style="margin-top:2em">
      <info-table
        :profile="profile"
        :updatePermissions="['USER.UPDATE', 'PROFILE.UPDATE']"
        @showEditModal="showEditModal"
      ></info-table>
    </v-flex>
    <profile-modal
      :show="isEditModalVisible"
      :id="profile.id"
      @close="hideEditModal"
      @update="updateProfile"
    ></profile-modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import ProfileModal from './modals/Profile.modal';
import { notificationsMixin } from '@/mixins/notifications';
import InfoTable from '../profile/InfoTable';

// @vuese
// Widok profilu klienta
// @group Client-Profile
export default {
  components: { ProfileModal, InfoTable },
  mixins: [notificationsMixin],
  data() {
    return {
      isEditModalVisible: false,
      active: undefined,
      profileModalClose: false,
      cardsModalClose: false
    };
  },
  computed: {
    ...mapState({
      profile: state => state.client.data.profile
    })
  },
  methods: {
    // @vuese
    // Funkcja wywołuje modal do edycji danych klienta
    showEditModal() {
      this.isEditModalVisible = true;
    },
    // @vuese
    // Funkcja ukrywa modal do edycji danych klienta
    hideEditModal() {
      this.isEditModalVisible = false;
    },
    // @vuese
    // Funkcja wywołuje metodę z store do edycji danych klienta
    // @arg `data` obiekt z danymi klienta do zapisania w bazie danych
    updateProfile(data) {
      try {
        store.dispatch('client/update', data).then(() => {
          this.notifySuccess('Zaktualizowano dane klienta.');
          this.hideEditModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się zaktualizować danych klienta.');
      }
    }
  },
  watch: {
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.isEditModalVisible ? this.hideEditModal() : (this.cardsModalClose = true);
        this.$store.dispatch('resetConfirmState');
      } else {
        if (this.cardsModalClose) {
          setTimeout(() => {
            this.cardsModalClose = false;
          }, 1000);
        }
      }
    }
  }
};
</script>
